export default __webpack_public_path__ + "static/mini_golf-252c109be5c15f27531f7d6894a493df.jpeg";